module.exports = __webpack_public_path__ + "static/media/makro19.7db044ef.md";